import React, { useEffect, useMemo, useState } from 'react'
import FuturePage from './FutureMainPage/index'
import FuturePrePage from './FuturePrePage/index'
import { custom4 } from "../../../../Utils/static-strings";

const Index = (props) => {
    const isMandGSA = sessionStorage.getItem("skinName")?.toLowerCase() === custom4?.toLowerCase();
    const [showPrePage, setShowPrePage] = useState(true);

    useEffect(() => {
        setShowPrePage(true);
    }, [isMandGSA]);

    const moduleObject = useMemo(() => {
        const questions = props.moduleObject?.questions || [];
        if (!isMandGSA || questions.length === 0) {
            return props.moduleObject;
        }
        const firstSetId = questions[0]?.qid?.split(".")[3]?.substring(0, 2);
        if (!firstSetId) {
            return props.moduleObject;
        }
        return {
            ...props.moduleObject,
            questions: questions.filter(
                (question) =>
                    question.qid?.split(".")[3]?.substring(0, 2) === firstSetId
            ),
        };
    }, [isMandGSA, props.moduleObject]);

    if (showPrePage) {
        return <FuturePrePage {...props} setPrePage={setShowPrePage} moduleObject={moduleObject} />
    }

    return <FuturePage {...props} moduleObject={moduleObject} />
}

export default Index
